import * as Yup from 'yup';
import createNovedadFormModel from './createTipoNovedadFormModel';

const {
  formField: {
    name,
    description,
    accion_1,
    resultado_1,
    cantidad_1,
    accion_2,
    resultado_2,
    cantidad_2,
    accion_3,
    resultado_3,
    cantidad_3,
    accion_4,
    resultado_4,
    cantidad_4,
  },
} = createNovedadFormModel;

export default [
  Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
  }),
];
